// Parmax - Swatch image switch on product cards
document.addEventListener('change', function (e) {
  const input = e.target;
  if (!input.matches('input.js-option[data-media-id]')) return;

  const card = input.closest('product-card');
  if (!card) return;

  const mediaId = input.dataset.mediaId;
  if (!mediaId) return;

  // Nascondi tutte le immagini della card
  card.querySelectorAll('[data-media-id]').forEach(function (img) {
    img.hidden = true;
  });

  // Mostra l'immagine della variante selezionata
  const target = card.querySelector('[data-media-id="' + mediaId + '"]');
  if (target) {
    target.hidden = false;
  } else {
    // Fallback: mostra la prima immagine
    const first = card.querySelector('.card__main-image');
    if (first) first.hidden = false;
  }
});